import { parse } from 'url';
import { UrlSearchState } from '@packages/common';

import {
  FACET_FILTER_KEY_SEPERATOR,
  FILTER_VALUE_SEPARATOR,
  FACET_FILTER_PREFIX,
  FACET_FILTER_SEPARATOR,
} from './constants';

const transformUrlToUrlSearchState = (url: string): UrlSearchState => {
  const { query } = parse(url);

  const facetFilters = query
    ? query.split(FACET_FILTER_SEPARATOR).reduce((acc, item) => {
        const [key, value] = item.split(FACET_FILTER_KEY_SEPERATOR);
        return {
          ...acc,
          [key.replace(FACET_FILTER_PREFIX, '')]: value
            .split(FILTER_VALUE_SEPARATOR)
            .map((value) => ({ value, isHero: false })),
        };
      }, {})
    : {};
  return facetFilters;
};

export default transformUrlToUrlSearchState;
